import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NotificationsResponse } from "../interfaces/notifications.interface";

const selectNotificationsFeatureState = createFeatureSelector<NotificationsResponse>("notifications");

export const selectNotifications = createSelector(
  selectNotificationsFeatureState,
  (state: NotificationsResponse) => state
);
